import { render, staticRenderFns } from "./TheMeetings.vue?vue&type=template&id=80a88ffe&"
import script from "./TheMeetings.vue?vue&type=script&lang=js&"
export * from "./TheMeetings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports